// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail {
    flex-basis: 0;
    flex-grow: 1;
    position: relative;
}

.thumbnail img {
    width: 100%;
    height: 80%;
    border: var(--border-style);
    cursor: pointer;
}

.unselected::before {
    background-color: rgba(229, 26, 27, 0.6);
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% + 2px);
    height: calc(80% + 2px);
    pointer-events: none;
}

.unselected:hover::before {
    background-color: rgba(229, 26, 27, 0.3);
}

.thumbnail div {
    padding: 20px 0;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/style/thumbnail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".thumbnail {\n    flex-basis: 0;\n    flex-grow: 1;\n    position: relative;\n}\n\n.thumbnail img {\n    width: 100%;\n    height: 80%;\n    border: var(--border-style);\n    cursor: pointer;\n}\n\n.unselected::before {\n    background-color: rgba(229, 26, 27, 0.6);\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: calc(100% + 2px);\n    height: calc(80% + 2px);\n    pointer-events: none;\n}\n\n.unselected:hover::before {\n    background-color: rgba(229, 26, 27, 0.3);\n}\n\n.thumbnail div {\n    padding: 20px 0;\n    font-weight: bold;\n    text-align: center;\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
